export const getBackPath = (pathname, appointmentTypeID) => {
  const backRoutes = {
    "/outlets": "/",
    "/select-services": "/outlets",
    "/guests-services": "/select-services",
    "/time": "/guests-services",
    "/review-and-confirm-booking": "/time",
    "/verify-identity": "/review-and-confirm-booking",
    "/verify-otp": "/verify-identity",
    "/contact-details": "/verify-identity",
    "/payment-options": "/contact-details",
    "/appointment/:uuid/select-time": "/appointment/:uuid",
    "/select-vouchers": "/",
    "/billing-details": "/select-vouchers",
    "/review-voucher-purchase": "/billing-details",
  };
  return backRoutes[pathname] || -1;
};
